export const FirebaseConfig = {
	"projectId": "taxi25-5633b",
	"appId": "1:1084513808597:web:3737604e37fb010d6b325c",
	"databaseURL": "https://taxi25-5633b-default-rtdb.firebaseio.com",
	"storageBucket": "taxi25-5633b.firebasestorage.app",
	"apiKey": "AIzaSyCxB0fGzzlrkj305reVsgHx_xaqR-122aY",
	"authDomain": "taxi25-5633b.firebaseapp.com",
	"messagingSenderId": "1084513808597",
	"measurementId": "G-P4FNK2X0SN"
};